export enum RouteNames {
  CameraConfigurations = 'CameraConfigurations',
  CameraConfigurationsSetup = 'CameraConfigurationsSetup',
  CameraManagement = 'CameraManagement',
  Cameras = 'Cameras',
}
